import Check from '../../../../assets/svg/Feather/Check';
import AlertCircle from '../../../../assets/svg/Feather/AlertCircle';
import ghAnalytics from '../../../../lib/analytics';

export default (dispatch) => ({
  finishImport() {
    dispatch({
      type: 'dataManager/setIsSavingImport',
      payload: true
    });

    dispatch({
      type: 'toast/show',
      payload: {
        text: 'Saving import...',
        loader: true,
        dismissable: true
      }
    });

    dispatch({
      type: 'features/setMoreFeaturesLoading',
      payload: true,
    });

    dispatch({
      type: 'features/getImportedData',
      callback: (result) => {
        dispatch({
          type: 'features/setMoreFeaturesLoading',
          payload: false,
        });
        dispatch({
          type: 'dataManager/setIsSavingImport',
          payload: false
        });
       if (!result) {
        ghAnalytics.logImportFailed();
        dispatch({
          type: 'toast/show',
          payload: {
            text: 'There was an issue saving your latest import',
            icon: AlertCircle,
            iconColor: '#FF3B30',
            dismissable: true
          }
        });
       } else {
        dispatch({
          type: 'collections/getImportedCollections',
          callback: (collection) => {
            if (result) {
              dispatch({
                type: 'collections/setMoreCollectionsLoading',
                payload: false,
              });
              dispatch({
                type: 'features/setFeaturesVisibility',
                payload: { collectionId: collection.uuid, visibility: true, type: 'collection' }
              });
            }
          }
        });
        dispatch({
          type: 'toast/show',
          payload: {
            text: 'Import saved',
            icon: Check,
            iconColor: '#F37735'
          }
        });
        dispatch({
          type: 'dataManager/reset'
        });
        setTimeout(() => {
          dispatch({
            type: 'toast/dismiss'
          });
        }, 3500);
    
       }
      },
    });
  },

  deleteImport() {
    dispatch({
      type: 'dataManager/setIsDeleting',
      payload: true
    });

    dispatch({
      type: 'dataManager/deleteLatestUpload',
      callback: (response) => {
        dispatch({
          type: 'dataManager/setIsDeleting',
          payload: false
        });

        if (!response) {
          dispatch({
            type: 'toast/show',
            payload: {
              text: 'There was an issue when deleting your latest import.',
              icon: AlertCircle,
              iconColor: '#FF3B30',
              dismissable: true
            }
          });
        } else {
          ghAnalytics.logImportDeleted();

          dispatch({
            type: 'toast/show',
            payload: {
              text: 'Import deleted',
              icon: Check,
              iconColor: '#F37735'
            }
          });

          setTimeout(() => {
            dispatch({
              type: 'toast/dismiss'
            });
          }, 3500);

          dispatch({
            type: 'dataManager/reset'
          });
        }
      }
    });
  }


});